import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-textarea-dialog',
  templateUrl: './textarea-dialog.component.html',
  styleUrls: ['./textarea-dialog.component.less'],
  standalone: false
})
export class TextAreaDialogComponent implements OnInit {


    constructor(
        private dialogRef: MatDialogRef<TextAreaDialogComponent>
        , @Inject(MAT_DIALOG_DATA) public data: {
            value: string,
            title: string,
        })
    { }

  ngOnInit(): void {
  }

    onSave() {
        this.dialogRef.close(this.data.value);
    }

    onCancel() {
        this.dialogRef.close();
    }

    copyToClipboard() {
        navigator.clipboard.writeText(this.data.value || '');
    }
}
